import React, { useEffect, useState } from "react";
import Header from "../components/headerfooter/Header";
import Footer from "../components/headerfooter/Footer";
import CallToAction from "../components/home/CallToAction";
import MobileFooter from "../components/MobileFooter";
import axios from "axios";
import { REACT_APP_API_PORT } from "../Api";
import Loader from "../components/Loader";
import moment from "moment/moment";
import { Helmet } from "react-helmet";

const Terms = () => {
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const getData = async () => {
      try {
        setisLoading(true);
        const res = await axios.get(`${REACT_APP_API_PORT}user/homepage/term-page-details`);
        setisLoading(false);
        if (res.data.status) {
          setData(res.data.data);
        }
      }
      catch (err) {
          setisLoading(false)
          console.log(err)
      }
  }

   const fetchMetaData = async () => {
    try {
      setisLoading(true);
      const res = await axios.get(
        `${REACT_APP_API_PORT}user/homepage/page-seo-details/Terms Page`
      );
      if (res.data.status) {
        setMeta(res.data.data)
      }
    } catch (err) {
      console.error(err);
    } finally {
      setisLoading(false);
    }
  };

  useEffect(() => {
    getData();
    fetchMetaData()
  }, []);
  return (
    <>
    <Helmet>
        <title>{meta?.meta_title}</title>
        <meta name="description" content={meta?.meta_description} />
        <meta name="keywords" content={meta?.meta_keywords} />
      </Helmet>
     <Loader isLoading={isLoading} />
   
      <Header />
      <div className="flex justify-center bg-black text-white">
        <div className="w-full px-4 pt-32">
          <div className="lg:w-2/4 w-full mx-auto">
            <h1 className="text-xl lg:text-[1.5rem] mt-10 font-sans font-extrabold mb-2">
              {data?.heading1}
            </h1>
            <span className="text-gray-400 text-sm italic">
            {
              (data?.updatedAt) && <>
              Updated on {moment(data?.updatedAt).format('llll')}
              </>
            }
            </span>
            <div className="mt-10">
            <div
                className="term-rich-text text-sm lg:text-base xl:text-lg font-medium text-white dark:text-white"
                dangerouslySetInnerHTML={{ __html: data?.description }}
              />
            
            </div>
          </div>
        </div>
      </div>
      <CallToAction />
      <Footer />
      <MobileFooter />
    </>
  );
};

export default Terms;
